import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';

const reviews = [
  {
    id: 'r1',
    text: '画风真的太绝了！每一帧都像壁纸一样精美，剧情也环环相扣，追更根本停不下来。这个平台更新速度也很快，强烈推荐！',
    author: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20soft%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-r1&orientation=squarish',
    role: 'VIP 读者',
  },
  {
    id: 'r2',
    text: '一直在找能稳定看韩漫的地方，终于找到了！资源很全，分类清晰，阅读体验也很流畅，已经推荐给身边所有喜欢漫画的朋友了。',
    author: '二次元少年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20man%20with%20glasses%2C%20friendly%20expression%2C%20simple%20background%2C%20clean%20illustration&width=120&height=120&seq=avatar-r2&orientation=squarish',
    role: '资深漫友',
  },
  {
    id: 'r3',
    text: '从学生时代就开始看韩漫，这个网站是我用过最好的。不仅有热门连载，还有很多经典老作品可以回味，真心好评！',
    author: '漫画老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20mature%20man%20with%20confident%20smile%2C%20simple%20dark%20background%2C%20clean%20illustration&width=120&height=120&seq=avatar-r3&orientation=squarish',
    role: '十年漫龄',
  },
  {
    id: 'r4',
    text: '韩漫大全真的是宝藏网站！翻译质量高，更新及时，而且界面设计也很舒服，看漫画的体验特别好。',
    author: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20long%20hair%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=120&height=120&seq=avatar-r4&orientation=squarish',
    role: '黄金会员',
  },
  {
    id: 'r5',
    text: '种类真的很全，从恋爱到悬疑什么都有。最重要的是不用翻墙，直接就能看，太方便了。',
    author: '北方的狼',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20cool%20young%20man%20with%20sharp%20features%2C%20simple%20cool%20tone%20background%2C%20clean%20illustration&width=120&height=120&seq=avatar-r5&orientation=squarish',
    role: '活跃读者',
  },
];

export default function ReaderReviews() {
  const { t } = useTranslation();
  const [activeIdx, setActiveIdx] = useState(0);

  const active = reviews[activeIdx];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <SectionTitle title={t('home.reviews.title')} subtitle={t('home.reviews.subtitle')} />

        <div className="flex flex-col lg:flex-row gap-0">
          <div className="relative lg:w-[40%] flex-shrink-0">
            <div className="bg-foreground-950 rounded-2xl p-8 md:p-10 lg:pr-16 h-full flex flex-col justify-center">
              <div className="mb-6">
                <i className="ri-double-quotes-l text-4xl text-accent-400/60"></i>
              </div>
              <p className="text-base md:text-lg text-background-50 leading-relaxed mb-6 min-h-[100px]">
                {active.text}
              </p>
              <div className="flex items-center gap-3 mb-6">
                <img
                  src={active.avatar}
                  alt={active.author}
                  className="w-12 h-12 rounded-lg object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-background-50">{active.author}</p>
                  <p className="text-xs text-background-50/50">{active.role}</p>
                </div>
              </div>
              <div className="flex gap-2">
                {reviews.map((r, idx) => (
                  <button
                    key={r.id}
                    onClick={() => setActiveIdx(idx)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      idx === activeIdx
                        ? 'bg-accent-500 w-6'
                        : 'bg-background-50/25 hover:bg-background-50/40'
                    }`}
                    aria-label={`Review ${idx + 1}`}
                  />
                ))}
              </div>
            </div>

            <div className="hidden lg:block absolute -right-4 top-1/2 -translate-y-1/2">
              <img
                src={active.avatar}
                alt={active.author}
                className="w-20 h-20 rounded-xl object-cover ring-4 ring-background-50"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-[60%] hidden lg:grid grid-cols-2 gap-3 pl-8 items-center">
            {reviews.slice(0, 4).map((r) => (
              <button
                key={r.id}
                onClick={() => setActiveIdx(reviews.indexOf(r))}
                className={`text-left p-5 rounded-xl transition-all duration-200 cursor-pointer ${
                  reviews.indexOf(r) === activeIdx
                    ? 'bg-secondary-50 border border-secondary-200'
                    : 'bg-background-100 border border-transparent hover:bg-background-100/80'
                }`}
              >
                <div className="flex items-center gap-3 mb-2">
                  <img
                    src={r.avatar}
                    alt={r.author}
                    className="w-9 h-9 rounded-lg object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{r.author}</p>
                    <p className="text-[11px] text-foreground-500">{r.role}</p>
                  </div>
                </div>
                <p className="text-xs text-foreground-600 line-clamp-3">{r.text}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}